import {cx} from "emotion";
import * as React from "react";

import "./corner.scss";

import {cs}        from "@Common/react/chain-services";
import {fragments} from "@Common/react/fragments";
import {chain}     from "@Common/utils/fs";

import {addVector}      from "../../../../common/add-vector";
import {BgCanvas}       from "../../../../common/bg-canvas";
import {Dragging}       from "../../../../common/dragging";
import {multiplyVector} from "../../../../common/multiply-vector";
import {pointsToRect}   from "../../../../common/points-to-rect";
import {rotatePoint}    from "../../../../common/rotate-point";
import {roundVector}    from "../../../../common/round-vector";
import {switchSize}     from "../../../../common/switch-size";
import {toCssRect}      from "../to-css-rect";

export const Corner = ({rotation, adjPoints, onChangedRect, next}) => cs(
    ["dragBox", (_, next) => DragBox({rotation, adjPoints, onChangedRect, next})],
    ({dragBox}) => next({
        modRect: dragBox.modRect,

        render: ({frame, start, limitSize, getBgColor}) => {
            const size = Math.max(1, Math.round(4 / frame.ratio));

            const s2 = [90,270].includes(rotation) ? switchSize(limitSize) : limitSize;

            // console.log("size", size);
            // console.log("limitSize", limitSize);

            // console.log("start", start);
            return fragments(
                dragBox.render({
                    backSize : size * 3,
                    frontSize: size * 6,
                    start, frame,
                }),

                //rotation === 270
                BgCanvas({
                    start,
                    rotation,
                    width : Math.min(size * 10, Math.floor(s2.width /2)),
                    height: Math.min(size * 10, Math.floor(s2.height/2)),
                    shouldShowColor: shouldShowColor(Math.ceil(size)),

                    getBgColor: getBgColor,
                    ratio: frame.ratio,
                }),
            );
        },
    })
);

const shouldShowColor = (size) => ({x, y}) => Math.min(x,y) < size;

const DragBox = ({rotation, adjPoints, onChangedRect, next}) => cs(
    ["dragging", (_, next) => Dragging({next})],
    ({dragging}) => {
        const modRect = dragging.active?.delta && (
            (rect) => {
                const delta = dragging.active.delta;

                const a = chain(
                    {x: -.5, y: -.5},
                    (_) => rotatePoint(_, rotation),
                    (_) => addVector(_, {x: .5, y: .5}),
                );

                const p2 = chain(
                    {
                        x: rect.x + (1 - a.x) * rect.width,
                        y: rect.y + (1 - a.y) * rect.height,
                    },
                    roundVector,
                );

                const p1 = chain(
                    {
                        x: rect.x + a.x * rect.width,
                        y: rect.y + a.y * rect.height,
                    },
                    (_) => addVector(_, delta),
                    roundVector,
                    (_) => adjPoints(p2, _),
                );
                // console.log(p1, p2);
                return pointsToRect(
                    p1,
                    p2,
                );
            }
        );
        return next({
            modRect,
            render: ({backSize, frontSize, start, frame}) => fragments(
                dragging.renderActive({
                    modDelta: (delta) => multiplyVector(delta, 1 / frame.ratio),
                    onDone: () => onChangedRect(modRect),
                }),
                <div {...{
                    className: cx("corner-52i drag-box", {dragging: dragging.active}),
                    draggable: false,
                    style: {
                        ...(() => {
                            const topLeft = chain(
                                {x: -backSize, y: -backSize},
                                (_) => rotatePoint(_, rotation),
                                (_) => addVector(start, _),
                                (_) => multiplyVector(_, frame.ratio),
                            );
                            const bottomRight = chain(
                                {x: frontSize, y: frontSize},
                                (_) => rotatePoint(_, rotation),
                                (_) => addVector(start, _),
                                (_) => multiplyVector(_, frame.ratio),
                            );
                            return toCssRect(pointsToRect(
                                topLeft,
                                bottomRight,
                            ));
                        })(),
                    },
                    ...dragging.handle,
                }}/>
            )
        });
    },
);
